// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Introduce_style_wrap__17ByQ","btnBox":"Introduce_style_btnBox__TyGHt"};